import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";

export default createStore({
    state: {
        routerInfo: {
            upjangTab: '',
            calcTypes: '',
            rcvTypes: '',
            dynamicParamUpjang: '',
            dynamicParam: '',
        }
    },
    mutations: {
        updateRouterInfo(state, data){
            if (data.upjangTab) {
                state.routerInfo.upjangTab = data.upjangTab
            }
            if (data.calcTypes) {
                state.routerInfo.calcTypes = data.calcTypes
            }
            if (data.rcvTypes) {
                state.routerInfo.rcvTypes = data.rcvTypes
            }
            if (data.dynamicParam) {
                state.routerInfo.dynamicParam = data.dynamicParam
            }
            if (data.dynamicParamUpjang) {
                state.routerInfo.dynamicParamUpjang = data.dynamicParamUpjang
            }
            console.log("mutations updateRouterInfo", state.routerInfo)
        },
        removeRouterInfo(state) {
            state.routerInfo = {
                upjangTab: '',
                calcTypes: '',
                rcvTypes: '',
                dynamicParam: '',
            }
        },
    },
    getters: {

    },
    actions: {
        setRouterInfo: ({commit}, data) => {
            console.log('commit setRouterInfo', data)
            commit('updateRouterInfo', data);
        },
        removeRouterInfo: ({commit}) => {
            commit('removeRouterInfo');
        }
    },
    modules: {},
    plugins: [
        createPersistedState()
    ]
})